import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { mainProgressBarReducer } from "../features/mainProgressBar/mainProgressBarSlice";
import spinnerSlice from "./slices/spinnerSlice";
import commonAlertSlice from "../features/alerts/commonAlert/commonAlertSlice";
import { orderFormPersistedReducer } from "../pages/orderPipeline/orderForm/orderFormSlice";
import { deliveryOptionPersistedReducer } from "../pages/orderPipeline/deliveryOptions/deliveryOptionSlice";
import { authPersistedReducer } from "../pages/layoutes/authLayout/authSlice";
import { topNavbarPersistReducer } from "../components/navbar/topNavbar/topNavbarSlice";
import { recommendedServicesPersistedReducer } from "../pages/orderPipeline/recommendedServices/recommendedServicesSlice";
import { baseApi } from "./api/baseApi";
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";

const reducer = combineReducers({
    [baseApi.reducerPath]: baseApi.reducer,
    //Sclices
    spinnerSlice,
    mainProgressBarSlice: mainProgressBarReducer,
    orderFormSlice: orderFormPersistedReducer,
    deliveryOption: deliveryOptionPersistedReducer,
    authSlice: authPersistedReducer,
    commonAlertSlice,
    topNavbarSlice: topNavbarPersistReducer,
    recommendedServicesSlice: recommendedServicesPersistedReducer,
});

type RootReducerState = ReturnType<typeof reducer>;

export const createStore = (preloadedState?: Partial<RootReducerState>) =>
    configureStore({
        reducer,
        devTools: !import.meta.env.PROD,
        preloadedState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                },
            }).concat(baseApi.middleware),
    });
const store = createStore();

export type AppStore = ReturnType<typeof createStore>;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;

export const persistor = persistStore(store);
